import Cookies from 'universal-cookie';

//export const host = "http://localhost:8080/"
export const host = "https://revault-api.herokuapp.com/"
const cookies = new Cookies();

export const token = cookies.get("token");

export const sendPlaystoreReply = async function (appId: string, storeId: string, reply: string) {
    const endpoint = host + "reviews/" + appId + "/playstore/reply";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({ 'id': storeId, 'replyText': reply })
        });

    if (!response.ok) {
        const message = 'Failed to send reply to Play Store. Please check your connection and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const sendAppstoreReply = async function (appId: string, storeId: string, reply: string) {
    const endpoint = host + "reviews/" + appId + "/appstore/reply";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({ 'id': storeId, 'replyText': reply })
        });

    if (!response.ok) {
        const message = 'Failed to send reply to App Store. Please check your connection and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const authenticateSubscription = async function (token: string) {
    const endpoint = host + 'subscription';

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

    if (!response.ok) {
        const message = 'Unable to verify your subscription. Please log in again or contact support if the problem persists. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const subscriptionData = await response.json();

    return subscriptionData;
}

export const appsFor = async function (subscriptionId: string, token: string) {
    const endpoint = host + 'apps/' + subscriptionId;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

    if (!response.ok) {
        const message = 'Failed to load your apps. Please refresh the page or try again later. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const apps = await response.json();

    return apps;
}

export const reviewsFor = async function (appId: string, token: string) {
    const endpoint = host + "reviews/" + appId;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Unable to load reviews for this app. Please check your app connections and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const reviews = await response.json();

    return reviews;
}

export const ratingsFor = async function (appId: string, type: string) {
    const endpoint = host + "ratings/" + type + "/" + appId;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to load app ratings. Please try again or check your app store connections. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const rating = await response.json();

    return rating;
}

export const issuesFor = async function (appId: string, token: string) {
    const endpoint = host + "issues?app=" + appId;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Unable to load issues for this app. Please refresh the page and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const issues = await response.json();

    return issues;
}

export const addIssue = async function (appId: any, name: string, kw: string) {
    const endpoint = host + "issues";
    var kws = kw.split(",")

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'app': appId.id,
                'title': name,
                'keywords': kws,
                'state': 'New'
            })
        });

    if (!response.ok) {
        const message = 'Failed to create new issue. Please check your input and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const updateIssueState = async function (issue: any, kw: string, state: string) {
    const endpoint = host + "issues/" + issue.id;
    var kws = kw.split(",")

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'title': issue.issue,
                'keywords': kws,
                'state': state
            })
        });

    if (!response.ok) {
        const message = 'Failed to update issue status. Please try again or contact support if the problem persists. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const updateIssue = async function (issue: any, kw: string) {
    const endpoint = host + "issues/" + issue.id;
    var kws = kw.split(",")

    var list = issue.keywords.concat(kws)

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'title': issue.issue,
                'keywords': list,
                'state': 'New'
            })
        });

    if (!response.ok) {
        const message = 'Failed to update issue keywords. Please verify the information and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const removeKeyword = async function (issue: any, kw: any) {
    const endpoint = host + "issues/" + issue.id;

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'title': issue.issue,
                'keywords': kw,
                'state': issue.state
            })
        });

    if (!response.ok) {
        const message = 'Failed to remove keyword from issue. Please try again or contact support if the problem persists. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const removeIssue = async function (id: string) {
    const endpoint = host + "issues/" + id;

    const response = await fetch(
        endpoint,
        {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to delete issue. Please check your permissions and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const message = await response.json();

    return message;
}

export const getCountries = async function () {
    const limit = 100;
    let offset = 0;
    let allCountries: any[] = [];
    let hasMore = true;

    while (hasMore) {
        const endpoint = `https://api.restcountries.com/countries/v5?response_fields=names.common,codes.alpha_2&limit=${limit}&offset=${offset}`;

        const response = await fetch(
            endpoint,
            {
                method: 'GET',
                headers: {
                    "Authorization": "Bearer rc_live_f743dc92a7e24b9fa5bc1b1a7cad8aa1"
                }
            });

        if (!response.ok) {
            const message = 'Unable to load country data. Please check your internet connection and try again. (Error: ' + response.status + ')';
            throw new Error(message);
        }

        const paginatedData = await response.json();

        // Add countries from this page
        paginatedData.data.objects.forEach((country: any) => {
            allCountries.push({
                name: country.names.common,
                code: country.codes.alpha_2
            })
        });

        // Check if there are more pages
        // The pagination metadata can be in data.meta or root level meta
        const paginationMeta = paginatedData.data.meta || paginatedData.meta;
        hasMore = paginationMeta?.more ?? false;
        offset += limit;

        console.log(`Loaded ${paginatedData.data.objects.length} countries at offset ${offset - limit}. More: ${hasMore}`);
    }

    console.log('Total countries loaded:', allCountries.length);
    return allCountries.sort((a: any, b: any) => a.name.localeCompare(b.name));
}

export const getStages = async function (token: string, appId: string) {
    const endpoint = host + "stages/" + appId;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Unable to load stages for this app. Please refresh the page and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const stages = await response.json();

    return stages;
}

export const getQueriesForStage = async function (token: string, stageId: string) {
    const endpoint = host + "results/" + stageId;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to load stage results. Please check your connection and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const saveStage = async function (app: any, data: any) {
    const endpoint = host + "stages/" + app.id;
    const today = new Date();

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'id': data.id,
                'app': app,
                'name': data.name,
                'status': data.status,
                'questions': data.questions,
                'first_message': data.first_message,
                'second_message': data.second_message,
                'final_message': data.final_message,
                'ask_every': data.ask_every,
                'creation_date': today,
                'version_toggle': data.version_toggle,
                'type': data.type,
                'questionType': data.questionType,
            })
        });

    if (!response.ok) {
        const message = 'Failed to save stage. Please check your input and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const updateStage = async function (token: string, id: any, status: any) {
    const endpoint = host + "stages/" + id;

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'status': status,
            })
        });

    if (!response.ok) {
        const message = 'Failed to update stage status. Please verify the information and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const deleteStage = async function (token: string, id: any) {
    const endpoint = host + "stages/" + id;

    const response = await fetch(
        endpoint,
        {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            }
        });

    if (!response.ok) {
        const message = 'Failed to delete stage. Please check your permissions and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const saveApp = async function (app: any, subscription: any) {
    const endpoint = host + "apps";

    let url = '';

    if (app.icon) {
        url = await uploadFile(app.icon, app.name);
    }

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'subscription': subscription.id,
                'icon': url,
                'url': "https://itunes.apple.com/" + app.countryCode + "/rss/customerreviews/page=1/id=" + app.appleAppId + "/sortby=mostrecent/json",
                'name': app.name,
                'country': app.country,
                'androidjsonfile': app.androidJsonFile,
                'androidpackageid': app.androidPackageId,
                'androidbucketid': app.androidBucketId,
                'app_gallery_id': app.appGalleryId,
                'countrycode': app.countryCode.toLowerCase(),
                'appleappid': app.appleAppId,
                'issuerid': app.issuerid,
                'keyid': app.keyid,
                'key': app.key,
            })
        });

    if (!response.ok) {
        const message = 'Failed to save app. Please check your app information and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;

}

export const updateApp = async function (id: any, app: any, subscription: any) {
    const endpoint = host + "apps/" + id;

    let url = '';

    if (app.icon) {
        url = await uploadFile(app.icon, app.name);
    }

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'icon': url,
                'url': "https://itunes.apple.com/" + app.countryCode + "/rss/customerreviews/page=1/id=" + app.appleAppId + "/sortby=mostrecent/json",
                'name': app.name,
                'country': app.country,
                'androidpackageid': app.androidpackageid,
                'countrycode': app.countrycode.toLowerCase(),
                'appleappid': app.appleappid,
                'app_gallery_id': app.app_gallery_id,
                'additional_countries': app.additional_countries || [],
            })
        });

    if (!response.ok) {
        const message = 'Failed to update app settings. Please verify your information and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;

}

export const updateNotificationStatus = async function (id: any, status: boolean, notificationEmail: string) {
    const endpoint = host + "apps/" + id + "/notification/update";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'status': status,
                'email': notificationEmail
            })
        });

    if (!response.ok) {
        const message = 'Failed to update notification settings. Please try again or contact support. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const connectPlaystore = async function (id: any, data: any) {
    const endpoint = host + "apps/" + id + "/playstore/connect";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'androidjsonfile': data.androidjsonfile,
                'androidbucketid': data.androidbucketid,
                'androidpackageid': data.androidpackageid,
                'connect': data.connect
            })
        });

    if (!response.ok) {
        const message = 'Failed to connect to Play Store. Please verify your credentials and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const connectAppstoreConnect = async function (id: any, data: any) {
    const endpoint = host + "apps/" + id + "/appStore/connect";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'key': data.key,
                'keyid': data.keyid,
                'issuerid': data.issuerid,
                'connect': data.connect
            })
        });

    if (!response.ok) {
        const message = 'Failed to connect to App Store Connect. Please check your API keys and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const connectSlack = async function (id: any, data: any) {
    const endpoint = host + "apps/" + id + "/slack/connect";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'url': data.slackwebhook,
            })
        });

    if (!response.ok) {
        const message = 'Failed to connect to Slack. Please verify your webhook URL and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const connectTeams = async function (id: any, data: any) {
    const endpoint = host + "apps/" + id + "/teams/connect";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'url': data.teamswebhook,
            })
        });

    if (!response.ok) {
        const message = 'Failed to connect to Microsoft Teams. Please verify your webhook URL and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const deleteApp = async function (id: any) {
    const endpoint = host + "apps/" + id;

    const response = await fetch(
        endpoint,
        {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            }
        });

    if (!response.ok) {
        const message = 'Failed to delete app. Please try again or contact support. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const saveNewSubscription = async function (subscription: any, plan: string) {
    var endpoint = host + "subscriptions";

    let url = '';

    if (subscription.profileimage) {
        url = await uploadFile(subscription.profileimage, subscription.name);
    }

    const expirationOffset = 365;
    const today = new Date();
    const future = new Date(today);
    future.setDate(today.getDate() + expirationOffset);

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'creationdate': today,
                'expirationdate': future,
                'name': subscription.name,
                'profileimage': url,
                'businessname': subscription.businessName,
                'plan': plan ?? 'AA',
                'email': subscription.email,
            })
        });

    if (!response.ok) {
        const message = 'Failed to create subscription. Please try again or contact support. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const updateSubscription = async function (subscription: any) {
    const endpoint = host + "subscriptions/" + subscription.id;

    let url = '';

    if (subscription.profileimage) {
        url = await uploadFile(subscription.profileimage, subscription.name);
    }

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'name': subscription.name,
                'profileimage': url,
                'businessname': subscription.businessName,
                'plan': subscription.plan,
                'email': subscription.email,
            })
        });

    if (!response.ok) {
        const message = 'Failed to update subscription. Please verify your information and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const updateState = async function (subscription: String, sessionId: String, customerId: String, subscriptionId: String, plan: string) {
    const endpoint = host + "subscriptions/status/" + subscription;

    const response = await fetch(
        endpoint,
        {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'checkoutsession': sessionId,
                'customerid': customerId,
                'subscriptionid': subscriptionId,
                'plan': plan,
                'status': 'active',
            })
        });

    if (!response.ok) {
        const message = 'Failed to update subscription status. Please contact support. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;
}

export const downloadReport = async function (app: any, month: any, year: any) {

    let monthNumber = new Date(`${month} 1, ${year}`).getMonth() + 1;

    const endpoint = host + "report/" + app.id + "?month=" + monthNumber + "&year=" + year;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            }
        });

    if (!response.ok) {
        const message = 'Failed to download report. Please check if data exists for the selected period and try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.blob();

    return success;
}

export const uploadFile = async function (file: any, name: any) {
    const endpoint = 'https://api.cloudinary.com/v1_1/dwggfdgyw/image/upload'

    const data = new FormData();
    data.append('file', file);
    data.append('public_id', addUniqueTimestampToFileName(name));
    data.append('upload_preset', 'ml_default');

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            body: data
        });

    if (!response.ok) {
        const message = 'Failed to upload file. Please check your file format and internet connection, then try again. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const responseData = await response.json();
    const secureUrl = responseData.secure_url;

    return secureUrl;
}

export const getTopData = async function (app: any, type: any) {
    const endpoint = host + "predictor/" + app + "?type=" + type;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to fetch analytics data. Please try again later. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}

export const customer = async function (session: String, token: string) {
    var endpoint = host + "api/stripe/customer";

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'session': session
            })
        });

    const success = await response.json();

    return success;
}

export const checkoutSubscription = async function (plan: any, price: any, location: string, subscriptionId: string) {
    var endpoint = host + "api/stripe/checkout";
    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                subscriptionId: subscriptionId,
                price: price,
                plan: plan,
                location: location
            })
        });

    if (!response.ok) {
        const message = 'Failed to create checkout session. Please try again or contact support. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;

}

export const customerPortal = async function (subscription: any, currentEndpoint: string) {
    var endpoint = host + "api/stripe/customer-portal";
    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'url': currentEndpoint,
                'customer': subscription.customerid
            })
        });

    if (!response.ok) {
        const message = 'Failed to access customer portal. Please try again later. (Error: ' + response.status + ')';
        throw new Error(message);
    }

    const success = await response.json();

    return success;

}

function addUniqueTimestampToFileName(fileName: string) {
    const now = new Date();

    // Format the timestamp including milliseconds (YYYYMMDD_HHMMSSmmm)
    const timestamp = now.toISOString()
        .replace(/[-:T]/g, '')  // Remove unwanted characters
        .replace(/\..+/, '');   // Remove milliseconds part after '.'

    const milliseconds = now.getMilliseconds().toString().padStart(3, '0');  // Ensures 3-digit ms
    const uniqueId = `${timestamp}${milliseconds}`;

    const extension = fileName.slice(fileName.lastIndexOf('.'));
    const nameWithoutExtension = fileName.slice(0, fileName.lastIndexOf('.'));

    return `${nameWithoutExtension}_${uniqueId}${extension}`;
}
